import { ILanguageOption } from '../interfaces/LanguageOption.interface';
import { LanguageCodes } from '../types/i18n';

export const languageOptions: ILanguageOption[] = [
  { label: 'العربية', flagCode: 'SA', languageCode: LanguageCodes.AR },
  { label: 'English', flagCode: 'US', languageCode: LanguageCodes.EN },
];
